<template>
    <div class="footer-tip">
        <span class="sp1" />
        <span class="sp2" :class="sign" />
    </div>
</template>

<script>
export default {
    name: 'FooterTip',
    props: {
        sign: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-tip {
    display: flex;
    height: 38px;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;

    span {
        background-size: 100% 100%;
        background-repeat: no-repeat;

        &.sp1 {
            width: 10px;
            height: 10px;
            background-image: url(@/assets/images/common/footer/icon.svg);
            margin: 0 4px 0 0;
        }

        &.sp2 {
            width: 128px;
            height: 9px;
            background-image: url(@/assets/images/common/footer/text.svg);
            background-size: auto 100%;

            &.kuaikan {
                width: 198px;
                background-image: url(@/assets/images/common/footer/text-kuaikan-new.svg);
            }
            &.metaso {
                width: 198px;
                background-image: url(@/assets/images/common/footer/text-metaso-new.svg);
            }
        }
    }
}
</style>